<mat-dialog-content>
  <p>Are you sure you want to delete this?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Delete</button>
</mat-dialog-actions>